var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 3.33337C6.22464 3.33337 5.80072 3.50897 5.48816 3.82153C5.17559 4.13409 5 4.55801 5 5.00004V8.33337H6.66667V5.00004H13.3333V7.50004H11.25L14.1667 10.4167L17.0833 7.50004H15V5.00004C15 4.55801 14.8244 4.13409 14.5118 3.82153C14.1993 3.50897 13.7754 3.33337 13.3333 3.33337H6.66667ZM2.5 10V11.6667H9.16667V10H2.5ZM2.5 12.5V14.1667H9.16667V12.5H2.5ZM10.8333 12.5V14.1667H17.5V12.5H10.8333ZM2.5 15V16.6667H9.16667V15H2.5ZM10.8333 15V16.6667H17.5V15H10.8333Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStpIcon);
export default __webpack_public_path__ + "static/media/stp-icon.e879fbb55e725a7dc2a4a39d990c305c.svg";
export { ForwardRef as ReactComponent };